// Synthetic advisers of the demo workspace. Names and addresses are
// invented; the .demo domain cannot receive mail, which is deliberate.
export const demoRms = [
    { rm_id: 'rm-demo-01', full_name: 'Alvaro Nieto', email: 'alvaro.nieto@despacho.demo' },
    { rm_id: 'rm-demo-02', full_name: 'Clara Sanchis', email: 'clara.sanchis@despacho.demo' },
    { rm_id: 'rm-demo-03', full_name: 'Ruben Olmedo', email: 'ruben.olmedo@despacho.demo' },
    { rm_id: 'rm-demo-04', full_name: 'Marta Lecuona', email: 'marta.lecuona@despacho.demo' },
];

// Twelve rows of the synthetic extract, with the fields the role dashboards
// read. Spanish identities and a Spanish-plausible country mix, in euro.
export const demoCustomers = [
    { customer_id: 'CUST3490', customer_name: 'Mercedes Arteaga Pons', age: 61, country_iso: 'ESP', risk_profile: 10, knowledge_score: 0, rm_id: 'rm-demo-01', segment: 'High-risk conviction', portfolio: 'Aspirational Dynamic', allocation_drift: 18, evidence_score: 58 },
    { customer_id: 'CUST3089', customer_name: 'Joaquin Belmonte Rivas', age: 46, country_iso: 'ESP', risk_profile: 8, knowledge_score: 42, rm_id: 'rm-demo-01', segment: 'Social-hype momentum', portfolio: 'Growth tilted', allocation_drift: 14, evidence_score: 72 },
    { customer_id: 'CUST3511', customer_name: 'Rosario Iglesias Varela', age: 72, country_iso: 'ESP', risk_profile: 9, knowledge_score: 75, rm_id: 'rm-demo-02', segment: 'Leveraged active trader', portfolio: 'Aspirational Dynamic', allocation_drift: 22, evidence_score: 81 },
    { customer_id: 'CUST2973', customer_name: 'Pilar Oyarzabal Cano', age: 55, country_iso: 'PRT', risk_profile: 9, knowledge_score: 11, rm_id: 'rm-demo-02', segment: 'Drawdown recovery', portfolio: 'Capital Protection', allocation_drift: 11, evidence_score: 64 },
    { customer_id: 'CUST2853', customer_name: 'Teodoro Bustamante Lazo', age: 64, country_iso: 'FRA', risk_profile: 2, knowledge_score: 98, rm_id: 'rm-demo-03', segment: 'Home-bias concentration', portfolio: 'Sustainable Core', allocation_drift: 17, evidence_score: 93 },
    { customer_id: 'CUST4126', customer_name: 'Amalia Cifuentes Robles', age: 58, country_iso: 'ESP', risk_profile: 4, knowledge_score: 61, rm_id: 'rm-demo-03', segment: 'Income preservation', portfolio: 'Balanced 60/40', allocation_drift: 6, evidence_score: 96 },
    { customer_id: 'CUST4188', customer_name: 'Eusebio Mendizabal Prats', age: 69, country_iso: 'ESP', risk_profile: 7, knowledge_score: 48, rm_id: 'rm-demo-04', segment: 'Recency-driven switcher', portfolio: 'Growth tilted', allocation_drift: 12, evidence_score: 77 },
    { customer_id: 'CUST4231', customer_name: 'Nieves Aguirrezabala Gil', age: 51, country_iso: 'ESP', risk_profile: 3, knowledge_score: 67, rm_id: 'rm-demo-04', segment: 'Loss-sensitive income', portfolio: 'Capital Protection', allocation_drift: 4, evidence_score: 98 },
    { customer_id: 'CUST4310', customer_name: 'Casimiro Valbuena Ortega', age: 47, country_iso: 'ESP', risk_profile: 6, knowledge_score: 55, rm_id: 'rm-demo-01', segment: 'Balanced but anchored', portfolio: 'Balanced 60/40', allocation_drift: 8, evidence_score: 89 },
    { customer_id: 'CUST4386', customer_name: 'Remedios Quintanilla Baeza', age: 36, country_iso: 'ESP', risk_profile: 8, knowledge_score: 35, rm_id: 'rm-demo-02', segment: 'Familiarity overweight', portfolio: 'Sustainable Core', allocation_drift: 15, evidence_score: 70 },
    { customer_id: 'CUST4449', customer_name: 'Gervasio Lameiro Castro', age: 42, country_iso: 'MEX', risk_profile: 5, knowledge_score: 83, rm_id: 'rm-demo-03', segment: 'Tax-sensitive allocator', portfolio: 'Balanced 60/40', allocation_drift: 5, evidence_score: 91 },
    { customer_id: 'CUST4527', customer_name: 'Soledad Bermudez Ocana', age: 53, country_iso: 'ESP', risk_profile: 7, knowledge_score: 52, rm_id: 'rm-demo-04', segment: 'High-conviction ESG', portfolio: 'Sustainable Core', allocation_drift: 10, evidence_score: 84 },
];

export const demoBiasRanking = [
    { bias_name: 'loss_aversion', mean_score: 74, n: 384 },
    { bias_name: 'overconfidence', mean_score: 69, n: 317 },
    { bias_name: 'recency_bias', mean_score: 66, n: 286 },
    { bias_name: 'familiarity_bias', mean_score: 62, n: 251 },
    { bias_name: 'mental_accounting', mean_score: 58, n: 239 },
    { bias_name: 'anchoring', mean_score: 54, n: 214 },
    { bias_name: 'confirmation_bias', mean_score: 51, n: 188 },
    { bias_name: 'regret_aversion', mean_score: 47, n: 163 },
];

export const demoSegments = [
    { segment: 'High-risk conviction', count: 248, percentage: 22.1 },
    { segment: 'Loss-sensitive income', count: 211, percentage: 18.8 },
    { segment: 'Recency-driven switcher', count: 185, percentage: 16.5 },
    { segment: 'Home-bias concentration', count: 171, percentage: 15.3 },
    { segment: 'Balanced but anchored', count: 162, percentage: 14.5 },
    { segment: 'Tax-sensitive allocator', count: 144, percentage: 12.8 },
];

export const demoAgeDistribution = [
    { bucket: '25-34', age_group: '25-34', count: 196, percentage: 17.5 },
    { bucket: '35-44', age_group: '35-44', count: 318, percentage: 28.4 },
    { bucket: '45-54', age_group: '45-54', count: 271, percentage: 24.2 },
    { bucket: '55-64', age_group: '55-64', count: 216, percentage: 19.3 },
    { bucket: '65+', age_group: '65+', count: 120, percentage: 10.7 },
];

export const getCustomerDisplayName = (customer = {}) => (
    customer.customer_name ||
    customer.full_name ||
    customer.name ||
    customer.client_name ||
    customer.customer_id ||
    'Customer'
);

export const getQueueOwnerLabel = (customer = {}, user, usingDemoData = false) => {
    if (!usingDemoData && !customer.is_synthetic && user?.role === 'admin' && user?.subscription === 'solo') {
        return 'you';
    }
    const rmId = customer.owner_rm_id || customer.rm_id;
    if (!rmId) return 'unassigned';
    const value = String(rmId);
    return value.length > 8 ? `${value.slice(0, 8)}…` : value;
};

const normalizedNumber = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

export const synthesizeRmsFromCustomers = (customers = []) => {
    const rmIds = Array.from(new Set(customers.map((customer) => customer.rm_id).filter(Boolean)));
    if (rmIds.length === 0) return demoRms;

    return rmIds.slice(0, 6).map((rmId, index) => ({
        rm_id: rmId,
        full_name: `RM ${index + 1}`,
        email: `rm${index + 1}@tenant.demo`,
    }));
};

// Enriches a who-to-call queue for display. Backend-computed fields
// (priority_score, urgency_level, recommended_action, top_biases, breakdown)
// are preserved when present; values are only synthesized for demo rows that
// have no computed score, and those rows are flagged with is_synthetic so the
// UI can disclose them. Synthetic-only fields (opportunity_eur) are never
// attached to live scored customers.
export const buildSyntheticWhoToCall = (customers = demoCustomers) => (
    (customers.length ? customers : demoCustomers)
        .map((customer, index) => {
            const risk = normalizedNumber(customer.risk_profile, 5);
            const drift = normalizedNumber(customer.allocation_drift, (index % 5) * 3 + risk);
            const knowledgeGap = Math.max(0, 100 - normalizedNumber(customer.knowledge_score, 55));
            const hasComputedScore = Number.isFinite(Number(customer.priority_score));
            const syntheticPriority = Math.min(10, Number((risk * 0.66 + drift * 0.08 + knowledgeGap * 0.018 + 1.1).toFixed(1)));
            const priority = hasComputedScore ? Number(customer.priority_score) : syntheticPriority;
            const urgency = customer.urgency_level || (priority >= 8 ? 'High' : priority >= 6.5 ? 'Medium' : 'Low');
            const recommendedAction = urgency === 'High'
                ? 'Schedule suitability review, confirm evidence, and document the behavioral rationale before next trade.'
                : urgency === 'Medium'
                    ? 'Prepare a check-in with allocation drift and bias talking points.'
                    : 'Keep in regular review and monitor benchmark drift.';

            return {
                ...customer,
                display_name: getCustomerDisplayName(customer),
                customer_id: customer.customer_id || `CUST-DEMO-${index + 1}`,
                rm_id: hasComputedScore ? customer.rm_id : (customer.rm_id || demoRms[index % demoRms.length].rm_id),
                priority_score: priority,
                urgency_level: urgency,
                opportunity_eur: hasComputedScore
                    ? null
                    : Math.round((risk * 52000 + drift * 11000 + 65000) / 1000) * 1000,
                recommended_action: customer.recommended_action || recommendedAction,
                top_biases: customer.top_biases || [
                    { bias_name: risk >= 7 ? 'Loss Aversion' : 'Anchoring', score: Math.min(100, 42 + risk * 5) },
                    { bias_name: drift >= 12 ? 'Familiarity Bias' : 'Mental Accounting', score: Math.min(100, 38 + drift * 3) },
                ],
                breakdown: customer.breakdown || {
                    risk_profile: risk,
                    allocation_drift: drift,
                    evidence_gap: Math.max(0, 100 - normalizedNumber(customer.evidence_score, 82)),
                },
                is_synthetic: !hasComputedScore,
            };
        })
        .sort((a, b) => b.priority_score - a.priority_score)
);

export const buildSyntheticActions = (customers = demoCustomers) => {
    const baseDate = new Date();
    baseDate.setHours(10, 0, 0, 0);

    return buildSyntheticWhoToCall(customers).slice(0, 10).map((customer, index) => {
        const created = new Date(baseDate);
        created.setDate(baseDate.getDate() - (index % 7));
        const updated = new Date(created);
        updated.setDate(created.getDate() + (index % 3));
        const status = index % 4 === 0 ? 'done' : index % 4 === 1 ? 'snoozed' : 'open';

        return {
            id: `demo-action-${customer.customer_id}`,
            customer_id: customer.customer_id,
            action_type: index % 3 === 0 ? 'meeting' : index % 3 === 1 ? 'call' : 'note',
            status,
            priority_score: customer.priority_score,
            created_at: created.toISOString(),
            updated_at: updated.toISOString(),
            next_contact_date: status === 'snoozed' ? new Date(baseDate.getTime() + 3 * 86400000).toISOString() : null,
            notes: customer.recommended_action,
        };
    });
};

export const demoInsights = {
    total_customers: 1121,
    segments: demoSegments,
    bias_ranking: demoBiasRanking,
    age_distribution: demoAgeDistribution,
};

export const demoPlatformImpact = {
    totalCustomers: 1121,
    assignedCustomers: 1049,
    avgRiskProfile: 5.6,
    qualifiedContacts: 146,
    highRiskCustomers: 213,
    urgentCustomers: 38,
    trackedCustomers: 92,
    appointmentsLogged: 24,
    completedActions: 57,
    avgResponseCycleDays: 1.8,
    segmentDistribution: demoSegments.map((segment, index) => ({
        name: segment.segment,
        value: segment.count,
        percentage: segment.percentage,
        color: ['#0B2545', '#38A169', '#805AD5', '#DD6B20', '#E53E3E', '#00B5D8'][index % 6],
    })),
    pipelineData: [
        { name: 'Qualified', value: 146, color: '#0B2545' },
        { name: 'Tracked', value: 92, color: '#38A169' },
        { name: 'Completed', value: 57, color: '#DD6B20' },
        { name: 'Deferred', value: 21, color: '#805AD5' },
    ],
    rmCoverage: demoRms.map((rm, index) => ({
        name: rm.full_name,
        customers: [286, 274, 251, 238][index],
        qualified: [42, 36, 33, 29][index],
    })),
    recentActivityData: ['16/5', '17/5', '18/5', '19/5', '20/5', '21/5', '22/5'].map((name, index) => ({
        name,
        logged: [8, 11, 9, 14, 12, 18, 20][index],
        completed: [4, 6, 5, 9, 7, 12, 14][index],
        deferred: [1, 2, 1, 3, 2, 4, 3][index],
    })),
    actionStatusData: [
        { name: 'Completed', value: 57, color: '#38A169' },
        { name: 'Deferred', value: 21, color: '#DD6B20' },
        { name: 'Appointments', value: 24, color: '#805AD5' },
        { name: 'Open', value: 35, color: '#0B2545' },
    ],
    workflowByRm: demoRms.map((rm, index) => ({
        name: rm.full_name,
        tracked: [31, 25, 21, 15][index],
        completed: [19, 17, 13, 8][index],
        deferred: [7, 5, 6, 3][index],
        meetings: [9, 7, 5, 3][index],
        overdue: [1, 2, 0, 1][index],
        completionRate: [61, 68, 62, 53][index],
        weeklyLogged: [12, 9, 7, 5][index],
        weeklyCompleted: [8, 6, 4, 3][index],
        weeklyMeetings: [4, 3, 2, 1][index],
        weeklyDeferred: [2, 2, 1, 1][index],
        weeklyCompletionRate: [67, 67, 57, 60][index],
    })),
    weeklySummary: {
        touchedCustomers: 64,
        coverageRate: 44,
        completedActions: 21,
        completionRate: 58,
        meetingsBooked: 10,
        meetingRate: 28,
        deferredActions: 6,
        overdueFollowUps: 4,
        openBacklog: 35,
        activeRms: 4,
    },
    weeklyWorkflowByRm: demoRms.map((rm, index) => ({
        name: rm.full_name,
        weeklyLogged: [12, 9, 7, 5][index],
        weeklyCompleted: [8, 6, 4, 3][index],
        weeklyMeetings: [4, 3, 2, 1][index],
        overdue: [1, 2, 0, 1][index],
        weeklyCompletionRate: [67, 67, 57, 60][index],
    })),
    isSyntheticDemo: true,
};

export const demoHeadDashboard = {
    total_customers: 1121,
    bias_ranking: demoBiasRanking,
    age_distribution: demoAgeDistribution,
    segments: demoSegments,
    metrics: {
        total_active_clients: 1121,
        average_account_tenure_days: 438,
        geographic_distribution: { ESP: 764, PRT: 121, FRA: 98, DEU: 64, MEX: 42, ARG: 32 },
        risk_tolerance_scores: { low: 264, medium: 644, high: 213 },
        executive_level_insights: { average_risk_profile: 5.6, customers_with_scores: 1121 },
        clients_with_bias_mitigated_pct: { '30d': 37, '90d': 61 },
        seat_utilization: {
            active_users_7d: 14,
            active_users_30d: 22,
            login_frequency: { daily: 8, weekly: 10, monthly: 4 },
            feature_usage: { dashboard_views: 226, report_downloads: 38, recommendations_accepted: 57 },
        },
        allocation_drift_risk: {
            clients_outside_bands: 189,
            pct_of_book: 16.9,
            drift_by_asset_class: { equity: 7.2, fixed_income: -4.8, cash: 3.4, alternatives: -2.1 },
        },
    },
    isSyntheticDemo: true,
};

export const demoPortfolioDashboard = {
    total_customers: 1121,
    bias_ranking: demoBiasRanking,
    age_distribution: demoAgeDistribution,
    segments: demoSegments,
    metrics: {
        mean_active_biases_per_client: 2.8,
        clients_trading_complex_products: 247,
        rebalance_coverage_pct: 74,
        bias_prevalence_matrix: demoBiasRanking.map((bias) => ({
            bias_name: bias.bias_name,
            prevalence_score: bias.mean_score,
        })),
        product_fit_hits: {
            'Capital protection': 269,
            'Diversified model': 347,
            'Income strategy': 202,
            'Sustainable core': 188,
        },
        risk_distribution_charts: { low: 264, medium: 644, high: 213 },
        allocation_drift_vs_model: { equity: 7.2, fixed_income: -4.8, cash: 3.4, alternatives: -2.1 },
        leverage_exposure_distribution: { low: 691, medium: 312, high: 118 },
        segment_bias_heatmap: demoSegments.flatMap((segment) => demoBiasRanking.slice(0, 3).map((bias) => ({
            segment: segment.segment,
            bias: bias.bias_name,
            score: bias.mean_score,
        }))),
        average_risk_scores: { suitability: 68, concentration: 54, volatility: 47 },
        disposition_effect_index: 0.42,
        home_country_overweight_share: 32,
        exportable_playbook: [
            { title: 'Review Aspirational Dynamic mismatch', description: 'High drift and high overconfidence concentration in the 25-44 cohort.', priority: 'High' },
            { title: 'Queue Capital Protection evidence checks', description: 'Loss-sensitive clients need suitability notes before next recommendation.', priority: 'High' },
            { title: 'Rebalance familiarity overweight', description: 'Home-country exposure exceeds the model threshold for 171 customers.', priority: 'Medium' },
            { title: 'Validate Sustainable Core ESG rationale', description: 'Confirm evidence completeness for high-conviction ESG profiles.', priority: 'Medium' },
        ],
    },
    isSyntheticDemo: true,
};

export const demoComplianceDashboard = {
    total_customers: 1121,
    risk_distribution: { low: 264, medium: 644, high: 213 },
    bias_severity_summary: {
        total_biases_detected: 1842,
        customers_with_biases: 876,
        severity_distribution: { low: 611, medium: 812, high: 361, critical: 58 },
    },
    metrics: {
        rka_pass_rates: { overall: 86 },
        stop_loss_usage_rates: 74,
        mean_rules_failed: 1.7,
        leverage_ratios: { mean: 1.18, max: 2.85, clients_above_2x: 74 },
        average_max_drawdown: 13.4,
        regulatory_compliance_monitoring: {
            high_risk_clients_count: 213,
            high_risk_percentage: 19.0,
            clients_with_excessive_leverage: 74,
            clients_with_severe_drawdowns: 96,
        },
        days_since_last_breach: 4,
        export_volume: { csv: 12, pdf: 7, png: 4 },
        pii_exposure_check: { total_views: 128, total_masked_views: 128, overall_masking_pct: 100 },
        latency_slo_monitor: { p50_ms: 210, p95_ms: 780, p99_ms: 1150, sample_size: 1280, slo_breached: false },
        audit_evidence_completeness_pct: 91,
    },
    isSyntheticDemo: true,
};
